/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { UID } from '@models/uid.model';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-layers-min',
  templateUrl: './widget-layers-min.component.html',
  styleUrls: ['./widget-layers-min.component.css']
})
export class WidgetLayersMinComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: UID;

  color = ItemColor('widgets');

  constructor() {}

  receiveValue(value: number) {
    this.widgetLayers.layer(this.current).change({ gaugeMin: value });
    if(this.widgetLayers.uid.value === this.current) this.widgetLayers.duplicateLayersOptions({ gaugeMin: value }, this.current);
  }

}
